import { DisclosureStateIndicatorProps } from './@types/DisclosureStateIndicatorProps';
import { useDisclosureLayout } from '../DisclosureLayout/hooks/useDisclosureLayout';
import SlotComponent from '../../SlotComponent';

const DisclosureStateIndicator = (props: DisclosureStateIndicatorProps) => {
	const { Show, Hide } = props;
	const { isOpen } = useDisclosureLayout();
	if (isOpen && Show) return <SlotComponent props={Show} />;
	if (!isOpen && Hide) return <SlotComponent props={Hide} />;
	return null;
};

export default DisclosureStateIndicator;
